/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTableCustom } from '../../../hooks/useTableCustom';
import { tasksAdapter } from '../adapters/tasks.adapter';
import { useNavigate } from 'react-router-dom';
import { IResponsePayload, useApiRequest } from '../../../hooks/useApiRequest';
import { ITask } from '../../../interfaces/project.interface';
import { URLS } from '../../../constants/urls.constants';
import { resetState } from '../../../store/modules/steps';
import { setAlert } from '../../../store/modules/snackbar';
import { stopLoading } from '../../../store/modules/loading';
import { RootState } from '../../../store';
import { setPage } from '../../../store/modules/page-table';

export const useNoRecurringTasksBase = () => {
	const { page, rowsPerPage } = useSelector((state: RootState) => state.pageTable);
	const {
		data: dataTable,
		setData: setDataTable,
		handleGetFiltersParams,
	} = useTableCustom<Object>({
		countRows: 0,
		rows: [],
		sort: { col: '', order: '' },
		pagination: page,
		rowsSelect: [],
		rowsPerPage: rowsPerPage,
		filters: {},
		advancedFilter: '',
		activeAdvanceFilter: false,
		filterCustom: {},
	});
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const {
		execute: executeGetTaskBase,
		status: statusGetTaskBase,
		value: valueTaskBase,
	} = useApiRequest<unknown, IResponsePayload<ITask>>({
		path: URLS.INCOMING_ROUTINES.NON_RECURRENT_TEMPLATE,
		method: 'GET',
	});

	const viewDetails = (task: ITask) => {
		dispatch(
			setPage({ page: dataTable.pagination, rowsPerPage: dataTable.rowsPerPage })
		);
		navigate('ver-supervision', {
			state: {
				params: {
					idRoutine: task?.routine,
					idSupervisionRoutine: task?.supervisionRoutine,
					isTask: true,
					isRecurring: false,
					isTaskBase: true,
				},
			},
		});
	};

	useEffect(() => {
		if (statusGetTaskBase === 'success') {
			dispatch(stopLoading());
			setDataTable({
				...dataTable,
				countRows: valueTaskBase?.totalRecords || 0,
				rows: tasksAdapter(valueTaskBase?.data || [], viewDetails),
				sort: {
					col: '',
					order: 'ASC',
				},
			});
			dispatch(resetState());
		} else if (statusGetTaskBase === 'error') {
			dispatch(
				setAlert({
					show: true,
					message:
						valueTaskBase?.message ||
						'Ha ocurrido un error, vuelva a recargar.',
					severity: 'error',
				})
			);
			dispatch(stopLoading());
		}
	}, [statusGetTaskBase]);

	return {
		dataTable,
		setDataTable,
		executeGetTaskBase,
		handleGetFiltersParams,
	};
};
